/* Stylesheet */

.value_input {
  padding: 4px;
  display: flex;
  align-items: center;
  background: var(--ion-gradient-light);
  border-radius: 42px;
  box-shadow: var(--ion-box-shadow);
  font-size: 0.875rem;

  .label {
    display: flex;
    justify-content: center;
    width: 58px;
  }

  .input {
    min-height: 21px;
    text-align: center;
    width: 58px;
    --highlight-color-focused: none;
    border-left: 1px solid #d8e2f2;
  }
}

.dark {
  background: var(--ion-color-dark-primary-lighter);

  .label {
    color: var(--ion-color-text-disabled);
  }

  .input {
    color: var(--ion-color-text-secondary);
  }
}

.disabled {
  opacity: 0.25;
  background: var(--ion-color-background-disabled);
}
